import { render, staticRenderFns } from "./VirtualTagTable.vue?vue&type=template&id=1eccb7b8&scoped=true&"
import script from "./VirtualTagTable.vue?vue&type=script&lang=js&"
export * from "./VirtualTagTable.vue?vue&type=script&lang=js&"
import style0 from "./VirtualTagTable.vue?vue&type=style&index=0&id=1eccb7b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eccb7b8",
  null
  
)

/* custom blocks */
import block0 from "./VirtualTagTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports